<template>
  <div class="clazz_create">
    <div class="choose_type">
      <van-radio-group v-model="postForm.rule_id">
        <van-cell-group>
          <van-cell icon="location-o" title="请选择班级规则"/>
          <van-cell
            v-for="(item, index) in ruleList"
            :key="index"
            :title="`${item.rule_name}（${item.day_num}天）`"
            title-class="cell-title"
            clickable
            @click="postForm.rule_id = item.uuid"
          >
            <van-radio :name="item.uuid" />
          </van-cell>
        </van-cell-group>
      </van-radio-group>

      <div class="px15">
        <bottom-btn class="mt2" title="下一步" :fixed="false" @click.native="showRuleDetail" />
      </div>
    </div>

    <!-- <van-popup class="full_popup" v-model="ruleDetailShow" position="right" :overlay="false">
      <div class="rule bgwhite">
        <van-cell-group>
          <van-cell title="总天数" :value="`${selectedRule.day_num}天`" />
          <van-cell v-if="selectedRule.run_distance" title="总公里数" :value="`${selectedRule.run_distance}KM`" />
        </van-cell-group>
        <rule-steps :clazz-type="selectedRule.clazz_type" :rule="selectedRule.rule_content" />
        <rule-content :clazz-type="selectedRule.clazz_type" :rule="selectedRule.rule_content" />
      </div>

      <div class="px15">
        <bottom-btn class="mt2" title="下一步" :fixed="false" @click.native="showTitle" />
        <bottom-btn class="mt2" title="上一步" :fixed="false" :cancel="true" @click.native="hideRuleDetail" />
      </div>
    </van-popup> -->

    <van-popup class="full_popup" v-model="titleShow" position="right" :overlay="false">
      <van-cell title="班级规则"
        :value="`${selectedRule.rule_name}（${selectedRule.day_num}天）`"
        value-class="cell-value"
      />
      <van-field
        class="name_field1"
        label="班级名称"
        v-model="postForm.clazz_name"
        placeholder="请输入班级名称"
      />

      <generic-picker v-model="postForm.day_distance" :columns="disList" title="每日距离" />

      <div class="week_range bgwhite">
        <div class="left">
          <span class="weight">{{ selectedRule.start_time_format|startDateFormat }}</span>
          至
          <span class="weight">{{ selectedRule.end_time_format|startDateFormat }}</span>
        </div>
        <div class="right">一共{{ selectedRule.day_num }}天</div>
      </div>

      <div class="px15">
        <bottom-btn class="mt2" title="下一步" :fixed="false" @click.native="gotoAdd" />
        <bottom-btn class="mt2" title="上一步" :fixed="false" :cancel="true" @click.native="hideTitle" />
      </div>
    </van-popup>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Popup, Field, Cell, CellGroup, RadioGroup, Radio, Toast } from 'vant'
import GenericPicker from '@/components/Picker/GenericPicker'
import DatePicker from '@/components/Picker/DatePicker'
// import RuleSteps from '@/views/clazz/components/RuleSteps'
import RuleContent from '@/views/clazz/components/RuleContent'
import BottomBtn from '@/components/BottomBtn'
import { allowRuleList, ruleInfo, addClazz } from '@/api/clazz_manage'
import { WeekDayFormat, formatDate } from '@/utils/index'

export default {
  name: 'ClazzCreate',
  components: {
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    GenericPicker,
    DatePicker,
    // RuleSteps,
    RuleContent,
    BottomBtn
  },
  data () {
    return {
      // disList: ['1km', '2km', '3km', '4km', '5km', '6km', '7km', '8km', '9km', '10km'],
      disList: ['1km', '2km', '3km', '5km'],
      monList: [],
      postForm: {
        clazz_name: '',
        day_distance: null,
        rule_id: ''
      },
      isLoaded: false,
      ruleList: [],
      selectedRule: {
        rule_name: '',
        content: null
      },
      ruleShow: false,
      ruleDetailShow: false,
      titleShow: false
    }
  },
  computed: {
    ...mapGetters([
      'is_leader'
    ]),
  },
  filters: {
    startDateFormat (value) {
      let date = new Date(value)
      return WeekDayFormat(date)
    }
  },
  created () {
    if (!this.is_leader) {
      this.$router.replace('/')
      return false
    }

    this.getRuleList()
  },
  methods: {
    async getRuleList () {
      let response = await allowRuleList()
      this.ruleList = response.data
    },
    async showRuleDetail () {
      if (!this.postForm.rule_id) {
        Toast({ message: '请选择规则', forbidClick: true })
        return false
      }

      let response = await ruleInfo(this.postForm.rule_id)
      this.selectedRule = response.data
      this.ruleDetailShow = true

      this.showTitle()
    },
    hideRuleDetail () {
      this.ruleDetailShow = false
    },
    showTitle () {
      this.titleShow = true
    },
    hideTitle () {
      this.titleShow = false
    },
    async gotoAdd () {
      if (!this.postForm.clazz_name) {
        Toast({ message: '请输入班级名称', forbidClick: true })
        return false
      }

      if (!this.postForm.day_distance) {
        Toast({ message: '请选择每日距离', forbidClick: true })
        return false
      }

      Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
      let response = await addClazz(this.postForm)
      Toast.clear()
      this.$router.replace('/manage/clazz/' + response.data.uuid)
    }
  }
}
</script>

<style scoped lang="scss">
.clazz_create {
  .name_field {
    margin: 80px auto 0 auto;
    width: 90%;
    border: 1PX solid #bbb;
    border-radius: 10px;
    font-size: 28px;
  }
  .week_range {
    font-size: 26px;
    color: #969696;
    background-color: #fcfcfc;
    padding: 30px 30px;
    display: flex;
    justify-content: space-between;
    .weight {
      color: #323233;
      font-size: 34px;
      // font-weight: bold;
    }
  }
}
.choose_type {
  .cell-title {
    flex: 7;
  }
}
.full_popup {
  width: 100%;
  height: 100%;
  background-color: #f8f8f8;
  .rule {
    // padding: 10px 0 10px 30px;
  }
  .cell-value {
    flex: 4;
  }
}
</style>
